import React, { useCallback } from "react";
import * as RadixDialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

import styles from "./Dialog.module.css";

export const Dialog = ({
  open,
  onClose,
  title,
  width = 560,
  minHeight,
  children,
  zIndex = 1300,
  modal = false,
  bodyClassName = "",
}) => {
  const handleOverlayClick = useCallback(() => onClose?.(), [onClose]);

  return (
    <RadixDialog.Root open={open} modal={modal}>
      {open && (
        <RadixDialog.Portal forceMount>
          <div
            className={styles.overlay}
            style={{ zIndex }}
            onClick={handleOverlayClick}
          />
          <RadixDialog.Content
            className={styles.content}
            style={{ width, minHeight, zIndex: zIndex + 1 }}
            aria-describedby={undefined}
            onOpenAutoFocus={(e) => e.preventDefault()}
            onEscapeKeyDown={() => onClose?.()}
          >
            <div className={styles.header}>
              <RadixDialog.Title className={styles.title}>
                {title}
              </RadixDialog.Title>
              <button
                className={styles.closeButton}
                aria-label="Close"
                onClick={onClose}
              >
                <X size={20} />
              </button>
            </div>

            <div className={`${styles.body} ${bodyClassName}`.trim()}>
              {children}
            </div>
          </RadixDialog.Content>
        </RadixDialog.Portal>
      )}
    </RadixDialog.Root>
  );
};
